export const roleRoutes: Record<string, string> = {
  "01": "/onevehicle",
  "02": "/fourvehicle",
  "03": "/lobby",
  "04": "/observe",
  "05": "/master",
  "07": "/bpslog",
};
